import Store, { RootState } from "../../../../redux/store";
import * as actions from "./file-download.actions";
import { createSelector } from "reselect";
import { IFileDownloadState } from "../types/file-downolad.interface";

export const getFileDownloadState = (state: RootState) => state.fileDownload;

export const isFetching = createSelector(
  getFileDownloadState,
  (fileDownloadState: IFileDownloadState) => fileDownloadState.fetching
);

export function download(
  url: string,
  fallbackName: string,
  authRequired: boolean = false,
  accept?: string
) {
  Store.dispatch(actions.download(url, fallbackName, authRequired, accept));
}
